import {
  CellKeyDownEvent,
  ColDef,
  ColGroupDef,
  PaginationChangedEvent,
  RowClickedEvent,
  SortChangedEvent,
  themeQuartz,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useEffect, useRef, useState } from "react";
// to use myTheme in an application, pass it to the theme grid option
const myTheme = themeQuartz.withParams({
  accentColor: "#E1FD88",
  backgroundColor: "#191919",
  browserColorScheme: "dark",
  chromeBackgroundColor: {
    ref: "foregroundColor",
    mix: 0.07,
    onto: "backgroundColor",
  },
  foregroundColor: "#FFF",
  headerFontSize: 14,
});
export interface GridDataProps<T> {
  pagination?: boolean;
  paginationCurrentDefault?: number;
  columnDefs: (ColDef<T, any> | ColGroupDef<T>)[];
  rowData: T[];
  onRowClicked?: (params: RowClickedEvent) => void;
  onSortChanged?: (event: SortChangedEvent) => void;
}

export const GridData = <T extends object>({
  pagination = true,
  paginationCurrentDefault = 1,
  columnDefs,
  rowData,
  onRowClicked,
  onSortChanged,
}: GridDataProps<T>) => {
  const [paginationPageSize, setPaginationPageSize] = useState<number>(20);
  const [paginationCurrent, setPaginationCurrent] = useState<number>(
    paginationCurrentDefault
  );
  const paginationPageSizeSelector = [20, 50, 100];
  const gridRef = useRef<AgGridReact>(null);
  // Row Data: The data to be displayed.

  const onPaginationChanged = (params: PaginationChangedEvent) => {
    if (params.newPage) {
      setPaginationCurrent(params.api.paginationGetCurrentPage());
    }
    if (params.newPageSize) {
      setPaginationPageSize(params.api.paginationGetPageSize());
    }
  };
  const onCellKeyDown = (event: CellKeyDownEvent) => {
    const eventKey = event.event as KeyboardEvent;

    if (eventKey.key === "c" && (eventKey.ctrlKey || eventKey.metaKey)) {
      navigator.clipboard.writeText(event.value);
      console.log(event.value);
    }
  };
  useEffect(() => {
    if (gridRef.current && gridRef.current.api) {
      if (
        gridRef.current.api.paginationGetCurrentPage() !==
        paginationCurrentDefault
      ) {
        gridRef.current.api.paginationGoToPage(paginationCurrentDefault);
      }
    }
  }, [paginationCurrentDefault]);

  return (
    <AgGridReact
      ref={gridRef}
      rowData={rowData}
      columnDefs={columnDefs}
      theme={myTheme}
      pagination={pagination}
      paginationPageSize={paginationPageSize}
      paginationPageSizeSelector={paginationPageSizeSelector}
      onPaginationChanged={onPaginationChanged}
      onCellKeyDown={onCellKeyDown}
      onRowClicked={onRowClicked}
      onSortChanged={onSortChanged}
      defaultColDef={{
        minWidth: 100,
        resizable: true,
        sortable: true,
      }}
    />
  );
};
